import { Button, Dropdown, Image, Menu, Tag, Typography } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import React from 'react';
import { Link } from 'react-router-dom';
import { SettingOutlined } from '@ant-design/icons';
import { ColumnsType } from 'antd/lib/table';
import { ItemType } from 'antd/lib/menu/hooks/useItems';

import { CommonTable } from 'components/CommonTable/CommonTable';
import { InvestmentProjectsItem } from 'store/slices/investmentProjects/interfaces';
import { getImageUrl } from 'utils/image';
import {
  ProjectStatuses,
  projectStatusesNames,
  Statuses,
  statusesColorsHash,
  statusesNamesHash,
} from 'constants/status';

import styles from './TableProjects.module.less';
import { NO_IMAGE } from './constants';

interface TableProjectsProps {
  total: number;
  getActions: (item: InvestmentProjectsItem) => ItemType[];
  setSort: (sort?: string) => void;
  limit?: number;
  items?: InvestmentProjectsItem[];
}

export const TableProjects = ({
  items = [],
  total,
  limit = 20,
  getActions,
  setSort,
}: TableProjectsProps) => {
  const columns: ColumnsType<TODO_ANY> = [
    {
      key: 'name',
      title: 'Название',
      sorter: true,
      dataIndex: 'name',
      render: (text: string, item: InvestmentProjectsItem) => (
        <Typography>
          <Link
            style={{ display: 'flex', alignItems: 'center', color: 'inherit' }}
            to={`/investmentProjects/${item.id}/edit`}
          >
            <div style={{ flexShrink: 0 }}>
              <Image
                width={50}
                height={50}
                preview={false}
                src={
                  item?.image
                    ? getImageUrl(item.image, 50, 50) || NO_IMAGE
                    : NO_IMAGE
                }
                fallback={NO_IMAGE}
                style={{ flexShrink: 0 }}
              />
            </div>
            <div style={{ marginLeft: '16px' }}>
              <div>{(text && text.trim()) || 'Без названия'}</div>
              {item.region && (
                <div
                  style={{
                    marginTop: '4px',
                    fontSize: '12px',
                    color: '#8C8C8C',
                  }}
                >
                  {item.region?.name}
                </div>
              )}
            </div>
          </Link>
        </Typography>
      ),
    },
    {
      key: 2,
      title: 'Статус реализации',
      width: '20%',
      dataIndex: 'projectStatus',
      render: (projectStatus: ProjectStatuses) => (
        <Typography>{projectStatusesNames[projectStatus]}</Typography>
      ),
    },
    {
      key: 3,
      width: '20%',
      title: 'Статус',
      dataIndex: 'status',
      render: (status: Statuses) => (
        <Tag color={statusesColorsHash[status]}>
          {statusesNamesHash[status]}
        </Tag>
      ),
    },
    {
      key: 4,
      title: '',
      width: 65,
      dataIndex: 'actions',
      fixed: 'right',
      render: (_: unknown, item: InvestmentProjectsItem) => (
        <Dropdown
          placement='bottomRight'
          overlay={
            <Menu className={styles.actionDropdown} items={getActions(item)} />
          }
          arrow
          trigger={['click']}
        >
          <Button type='text' icon={<SettingOutlined />} />
        </Dropdown>
      ),
    },
  ];

  return (
    <Content>
      <CommonTable
        columns={columns}
        scroll={{ x: 800 }}
        total={total}
        limit={limit}
        dataSource={items}
        setSort={setSort}
      />
    </Content>
  );
};
